import React from 'react';
import { useLocation } from 'react-router-dom';
import { Flex } from '../../UI/Flex';
import HistoricIcon from '../../Icons/HistoricIcon';
import PillsIcon from '../../Icons/PillsIcon';
import Typography from '../../Typography';
import { Box } from '../../UI/Box';
import MenuSandwichIcon from '../../Icons/MenuSandwichIcon';
import { Button } from '../../UI/Button';
import {
  NOT_OPEN_BOTTOM_BAR_HEIGHT,
  OPEN_BOTTOM_BAR_HEIGHT,
  usePrescriberContext,
} from 'src/providers/PrescriberProvider';
import DoctorIcon from '../../Icons/DoctorIcon';
import TutorialIcon from '../../Icons/TutorialIcon';
import CallCenterIcon from '../../Icons/CallCenterIcon';
import { AnimatePresence, motion } from 'framer-motion';
import { BottomTabButton } from './BottomTabButton';
import {
  trackMobileNavPrescriptionClick,
  trackMobileNavHistoryClick,
  trackMobileNavProfileClick,
  trackMobileNavMoreClick,
} from 'src/services/tracking/events';

export const BOTTOM_TAB_PADDING_BOTTOM = 5;

export function BottomTabNavigation() {
  const { search } = useLocation();

  const { bottomBarHeight, setBottomBarHeight, prescriberId } = usePrescriberContext();

  const isBottomBarOpened = bottomBarHeight === OPEN_BOTTOM_BAR_HEIGHT;

  const handleCloseBottomBar = async () => {
    setBottomBarHeight(NOT_OPEN_BOTTOM_BAR_HEIGHT);
  };

  const handlePrescriptionClick = () => {
    trackMobileNavPrescriptionClick(prescriberId || undefined);
    handleCloseBottomBar();
  };

  const handleHistoryClick = () => {
    trackMobileNavHistoryClick(prescriberId || undefined);
    handleCloseBottomBar();
  };

  const handleProfileClick = () => {
    trackMobileNavProfileClick(prescriberId || undefined);
    handleCloseBottomBar();
  };

  const handleMoreClick = () => {
    trackMobileNavMoreClick(prescriberId || undefined);
    setBottomBarHeight(OPEN_BOTTOM_BAR_HEIGHT);
  };

  return (
    <Box
      w={'100%'}
      zIndex={3}
      backgroundColor={'surface'}
      borderRadius={'20px 20px 0px 0px'}
      boxShadow={'0px -15px 100px 0px rgba(255, 182, 191, 0.3)'}
      p={'5px 5px 15px 5px'}
      pos={'fixed'}
      bottom={0}
    >
      <Flex justifyContent={'space-between'} alignItems={'center'} gap={'5px'}>
        <BottomTabButton
          pathTo={`/inicio/receita${search}`}
          onClick={handlePrescriptionClick}
          label={
            <Box>
              <PillsIcon variantColor="support.blue" width={20} />
              <Box mt={'5px'}>
                <Typography whiteSpace={'pre-wrap'} model={'body'} size={'normal'} textAlign={'center'} weight="bold">
                  Prescrição
                </Typography>
              </Box>
            </Box>
          }
        />
        <BottomTabButton
          pathTo={`/inicio/historico${search}`}
          onClick={handleHistoryClick}
          label={
            <Box>
              <HistoricIcon variantColor="support.blue" width={20} />
              <Box mt={'5px'}>
                <Typography whiteSpace={'pre-wrap'} model={'body'} size={'normal'} textAlign={'center'} weight="bold">
                  Historico
                </Typography>
              </Box>
            </Box>
          }
        />
        <BottomTabButton
          pathTo={`/inicio/meus-dados${search}`}
          onClick={handleProfileClick}
          label={
            <Box>
              <DoctorIcon variantColor="support.blue" width={20} />
              <Box mt={'5px'}>
                <Typography whiteSpace={'pre-wrap'} model={'body'} size={'normal'} textAlign={'center'} weight="bold">
                  Perfil
                </Typography>
              </Box>
            </Box>
          }
        />
        {!isBottomBarOpened && (
          <Button variant="ghost" w={'100%'} height={'100%'} borderRadius={'20px'} onClick={handleMoreClick}>
            <Box>
              <MenuSandwichIcon variantColor="support.blue" width={20} />
              <Box mt={'5px'}>
                <Typography whiteSpace={'pre-wrap'} model={'body'} size={'normal'} textAlign={'center'} weight="bold">
                  mais
                </Typography>
              </Box>
            </Box>
          </Button>
        )}
      </Flex>

      <AnimatePresence>
        {isBottomBarOpened && (
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
              height: 0,
            }}
            transition={{
              opacity: {
                duration: 0.2,
              },
              height: {
                duration: 0.3,
              },
            }}
            style={{ display: 'flex', gap: '5px', overflow: 'hidden' }}
          >
            <BottomTabButton
              pathTo={`/inicio/tutorial${search}`}
              onClick={handleCloseBottomBar}
              label={
                <Box>
                  <TutorialIcon variantColor={'support.blue'} width={20} />
                  <Box mt={'5px'}>
                    <Typography
                      whiteSpace={'pre-wrap'}
                      model={'body'}
                      size={'normal'}
                      textAlign={'center'}
                      weight="bold"
                    >
                      Tutoriais
                    </Typography>
                  </Box>
                </Box>
              }
            />
            <BottomTabButton
              pathTo={`/inicio/ajuda${search}`}
              onClick={handleCloseBottomBar}
              label={
                <Box>
                  <CallCenterIcon variantColor={'support.blue'} width={20} />
                  <Box mt={'5px'}>
                    <Typography
                      whiteSpace={'pre-wrap'}
                      model={'body'}
                      size={'normal'}
                      textAlign={'center'}
                      weight="bold"
                    >
                      Precisando de ajuda?
                    </Typography>
                  </Box>
                </Box>
              }
            />
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
}
